export const LOGIN_METHOD = {
    SIMPLE: "SIMPLE",
    KEYCLOAK: "KEYCLOAK"
};